import React, { useMemo /* , lazy */, useState } from "react";
import { PuceContext } from "context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "components/BackButton";
import servicesAPI from "services/servicesAPI";
import LoadComponent from "components/LoadComponent";
import ModuleTitle from "components/ModuleTitle";
import { Grid } from "@mui/material";
import { PATH_PUCE } from "constant/moduleInfo";
import { Box } from "@mui/system";
import MDButton from "components/MDButton";
import LotPuceDetails from "./components/LotPuceDetails";

// const GestionPuce = lazy(() => import("layouts/donneeReference/rubrique/gestionPuce"));
// import PuceLogs from "./components/PuceLog";

function DetailLotPuce() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { selectedData } = state;
  const [lotPuce, setLotPuce] = useState(selectedData);
  const { isAlert, isLoading, message, alertSeverity, handleLoad, getData, putData, postData } =
    servicesAPI();

  const loadDataConfig = useMemo(() => {
    const value = {
      isAlert,
      isLoading,
      message,
      alertSeverity,
      handleLoad,
    };
    return value;
  }, [isAlert, isLoading, message, alertSeverity]);
  const refresh = (data) => {
    setLotPuce(data);
  };
  const propsDataConfig = useMemo(() => {
    const value = {
      selectedData,
      ApiService: { getData, putData, postData, handleLoad },
      refresh,
    };
    return value;
  }, [selectedData]);
  const goToListPuce = () => {
    navigate(PATH_PUCE, { state: { lotPuce } });
  };

  return (
    <>
      <ModuleTitle title="Informations du lot de puces" />
      <BackButton />

      <PuceContext.Provider value={propsDataConfig}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LotPuceDetails />
          </Grid>

          {/* <Grid item xs={12}>
            <GestionPuce lotPuce={lotPuce} />
          </Grid> */}
        </Grid>
      </PuceContext.Provider>
      <Box display="flex" alignItems="center" justifyContent="center">
        <MDButton type="submit" variant="gradient" color="info" onClick={goToListPuce}>
          Voir la liste des puces du lot
        </MDButton>
      </Box>
      <LoadComponent loadData={loadDataConfig} />
    </>
  );
}

export default DetailLotPuce;
